<template>
  <el-dialog title="流程历史" v-model="modalShow" size="small" @close="closeModal()" @open="getFlowHistroy()" style="overflow: hidden">
    <div class="flowHistroy-container">
      <div class="ovf-hd">
        <div class="fr bor-ra-5 ovf-hd bor-gray">
          <div class="fl p-t-5 p-l-10 p-b-5 p-r-10 pointer" :class="{'active-tab': timeActive}" @click="switchActive(1)">
            <span class="fa fa-clock-o"></span>
            <span>时间轴</span>
          </div>
          <div class="fl p-t-5 p-l-10 p-b-5 p-r-10 pointer" :class="{'active-tab': listActive}" @click="switchActive(0)">
            <span class="fa fa-list"></span>
            <span>列表</span>
          </div>
        </div>
      </div>
      <div v-loading="isLoading">
        <div v-show="timeActive" class="contentActive">
          <div v-for="(item, index) in histroyData" class="m-t-20">
            <div class="fl w-100 h-60 tx-c pos-rel">
              {{ item.deal_time | toDate }}
              <div v-if="index != histroyData.length - 1" class="time-line">
                <div class="fa fa-dot-circle-o start"></div>
                <div class="fa fa-dot-circle-o end"></div>
              </div>
            </div>
            <div class="fl w-150 tx-c">
              <div>{{ item.realname }}</div>
              <div>（{{ item.post_name }}）</div>
            </div>
            <div class="fl m-l-10 bor-ra-5 bg-gra heig-60 w-300 bor-gray ovf-hd pad-6 pos-rel">
              <div class="w-300 ovf-hd ovf-hd">
                <div class="fl">{{ item.realname }}&nbsp;&nbsp;</div>
                <!-- <div class="fl bg-red circle c-wh fz-12 pad-2">
                  <i class="fa fa-reply"></i>
                </div>
                <div class="fl bg-green circle c-wh fz-12 pad-2">
                  <i class="fa fa-check"></i>
                </div> -->
              </div>
              <div class="consuming">{{ (item.deal_time - item.create_time) | spendTime }}</div>
            </div>
            <div style="clear: both"></div>
          </div>
        </div>
        <div v-show="listActive" class="m-t-20 contentActive">
          <el-table
            :data="histroyData"
            style="width: 100%">
            <el-table-column
              prop="node_name"
              label="审批节点"
              width="150">
            </el-table-column>
            <el-table-column
              label="办理人"
              width="200">
              <template scope="scope">
                {{ scope.row.realname }}（{{ scope.row.post_name }}）
              </template>
            </el-table-column>
            <el-table-column
              label="签核动作">
              <template scope="scope">
                {{ scope.row.examine_status | action}}
              </template>
            </el-table-column>
            <el-table-column
              label="办理时间">
              <template scope="scope">
                {{ scope.row.deal_time | toTime}}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<style scoped>
.active-tab {
  background: #009BFF;
  color: #fff
}
.heig-60 {
  height: 60px
}
.pad-2 {
  padding: 2px
}
.pad-6 {
  padding: 6px
}
.flowHistroy-container {
  width: 600px;
  margin: 0 auto;
  overflow: hidden
}
.contentActive {
  max-height: 300px;
  overflow-y: auto;
}
.consuming {
  position: absolute;
  top: 5px;
  right: 0px;
  width: 110px;
}
.time-line {
  position: absolute;
  top: 50px;
  left: 45px;
  width: 1px;
  height: 55px;
  background: #333;
}
.time-line > .start {
  position: absolute;
  top: -5px;
  left: -5px;
}
.time-line > .end {
  position: absolute;
  bottom: -5px;
  left: -5px;
}
</style>
<script>
  import http from '../../../assets/js/http'

  export default {
    name: 'flowHistroy',
    props: {
      modalShow: {
        type: Boolean,
        default() {
          return false
        }
      },
      caseId: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    data() {
      return {
        isLoading: false,
        timeActive: true,
        listActive: false,
        histroyData: []
      }
    },
    methods: {
      switchActive(type) {
        if (type) {
          this.timeActive = true
          this.listActive = false
        } else {
          this.timeActive = false
          this.listActive = true
        }
      },
      getRemote() {
        this.isLoading = !this.isLoading
        this.apiGet(`bpm/flowCases/${this.caseId}/history`).then((res) => {
          this.isLoading = !this.isLoading
          if (res.code == 200) {
            this.histroyData = res.data
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getFlowHistroy() {
        if (!this.histroyData.length) {
          this.getRemote()
        }
      },
      closeModal() {
        this.$emit('closeHistroy')
      }
    },
    filters: {
      action(val) {
        let action = '提交'
        switch (val) {
          case 10:
            action = '通过'
            break
          case 20:
            action = '不通过'
            break
          case 40:
            action = '撤回'
            break
        }
        return action
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// histroy.vue?10e79c75